import { camelToKebabCase, objectEntries } from "@instacover/utils"

import { SessionTheme } from "@/types/routerTypes"

// NOTE: variable names MUST match with design system CSS variables (--ic-*)
export async function setTheme(theme: SessionTheme) {
  const { colors, borderRadius, fonts } = theme

  // colors
  for (const [key, value] of objectEntries(colors)) {
    document.documentElement.style.setProperty(`--ic-colors-${camelToKebabCase(key)}`, value)
  }

  // fonts
  document.documentElement.style.setProperty("--ic-fonts-body", fonts.body)
  document.documentElement.style.setProperty("--ic-fonts-heading", fonts.heading)

  // border radius
  document.documentElement.style.setProperty("--ic-radius-primary", borderRadius)
}
